import { render, staticRenderFns } from "./user-coupon-car.vue?vue&type=template&id=675c47c1&"
import script from "./user-coupon-car.vue?vue&type=script&lang=js&"
export * from "./user-coupon-car.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports